import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer.attrs({className: 'footer-container'})`
  background: #F9FAFA;
  padding: 80px 116px 0;
  border-top: 1px solid #E5E5E5;
  scroll-snap-align: start;
    @media (max-width: 768px) {
      padding-left: 20px;
      padding-right: 20px;
    }
`;

const FooterContent = styled.div.attrs({className: 'footer-content'})`
  // max-width: 1280px;
  // margin: 0 auto;
  padding-bottom: 74px;
`;

const FooterTop = styled.div.attrs({className: 'footer-top'})`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    grid-template-areas:
      "a c"
      "b b";
  }
`;

const LogoSection = styled.div.attrs({className: 'logo-section'})`
  display: flex;
  gap: 20px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    grid-area: a;
  }
`;

const LogoImage = styled.img.attrs({className: 'logo-image'})`
  height: 40px;
  width: auto;
`;

const RightSideImages = styled.div.attrs({className: 'right-side-images'})`
  display: flex;
  gap: 20px;
  justify-content: end;

  @media (max-width: 768px) {
    grid-area: c;
  }
`;

const RightImage = styled.img.attrs({className: 'right-image'})`
  height: 40px;
  width: auto;
`;

const NavigationSection = styled.div.attrs({className: 'navigation-section'})`
  display: flex;
  // gap: 54px;
  // gap: clamp(30px, 4vw, 54px);
  gap: clamp(5px, 2vw, 54px);
  flex-wrap: no-wrap;
  white-space: nowrap;
  justify-content: space-around;

  @media (max-width: 768px) {
    display: grid;
    gap: 30px;
    grid-area: b;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "nav1 nav5"
      "nav2 nav6"
      "nav3 nav3"
      "nav4 nav4";
    & > *:nth-child(1) { grid-area: nav1; }
    & > *:nth-child(2) { grid-area: nav2; }
    & > *:nth-child(3) { grid-area: nav3; }
    & > *:nth-child(4) { grid-area: nav4; }
    & > *:nth-child(5) { grid-area: nav5; align-items: end; padding-right: 50%; }
    & > *:nth-child(6) { grid-area: nav6; align-items: end; padding-right: 50%; }
  }
`;

const NavGroup = styled.div.attrs({className: 'nav-group'})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  //font-size: clamp(8px, 1vw, 13px);
  font-size: clamp(7px, 0.9vw, 13px);
  @media (max-width: 768px) {
    font-size: 13px;
  }

  //お問合せリンク用
  .contact-link {
    color: #0F3F8E;
    text-decoration: none;
    }
`;

const NavLink = styled(Link).attrs({className: 'nav-link'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  //font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #333333;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #0F3F8E;
  }
    
`;

const SubNavLink = styled(Link).attrs({className: 'sub-nav-link'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  //font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #333333;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #0F3F8E;
  }
`;

const ContactLink = styled(NavLink).attrs({className: 'contact-link'})`
  color: #0F3F8E;
`;

const ContactSubLink = styled(SubNavLink).attrs({className: 'contact-sub-link'})`
  color: #0F3F8E;
`;

const Copyright = styled.div.attrs({className: 'copyright'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #9B9B9B;
  text-align: center;
  padding-top: 90px;

  @media (max-width: 768px) {
    padding-top: 60px;
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterTop>
          <LogoSection>
            <LogoImage src="/images/footer-logo.svg" alt="Lib-Gate Logo" />
          </LogoSection>
          
          <NavigationSection>
            <NavGroup>
              <NavLink to="/philosophy/">企業理念</NavLink>
            </NavGroup>
            
            <NavGroup>
              <NavLink to="/service/">事業紹介</NavLink>
              <SubNavLink to="/service/development/">開発</SubNavLink>
              <SubNavLink to="/service/creative/">クリエイティブ</SubNavLink>
              <SubNavLink to="/service/product/">プロダクト</SubNavLink>
            </NavGroup>
            
            <NavGroup>
              <NavLink to="/information/">お知らせ</NavLink>
              {/* <SubNavLink to="/information">一覧</SubNavLink> */}
            </NavGroup>
            
            <NavGroup>
              <NavLink to="/company/">企業情報</NavLink>
              <SubNavLink to="/privacy-policy/">プライバシーポリシー</SubNavLink>
            </NavGroup>
            
            <NavGroup>
              <a href="/contact/" className='contact-link'>お問合せ</a>
            </NavGroup>
            
            <NavGroup>
              <ContactLink to="https://xelenhd.com/careers/" target="_blank">採用情報</ContactLink>
              <ContactSubLink to="https://herp.careers/v1/xelen/requisition-groups/85f61ffa-d967-4da7-b8a3-8383d0487941" target="_blank">新卒採用</ContactSubLink>
              <ContactSubLink to="https://herp.careers/v1/xelen" target="_blank">中途採用</ContactSubLink>
            </NavGroup>
          </NavigationSection>
          
          <RightSideImages>
            <Link to="https://www.facebook.com/libgate/">
              <RightImage src="/images/footer-logo-1.png" alt="facebook" />
            </Link>
            <RightImage src="/assets/images/common/pmark.png" alt="Pマーク" />
          </RightSideImages>
        </FooterTop>
        
        <Copyright>
          {`©${new Date().getFullYear() || '2025'} Lib-Gate Co.,Ltd. All Rights Reserved.`}
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
